import React from 'react'
import downlod from '../../images/downloded.png'
import allow from '../../images/allow.png'
import GridContainer from '@dashboard/common/src/components/Grid/GridContainer'

const Steps = ({ downloaded, setDownloaded }) => {
  return (
    <>
        <div style={{ display: 'flex', marginTop: 10, justifyContent: 'center'}}>
            <p>Did not Work ?</p>
            <p style={{ color: '#01875f', fontWeight: 'bolder', marginLeft: 5}} onClick={() => setDownloaded(!downloaded)}>Download again</p>
        </div>
        <div style={{display: 'flex', marginTop: 10, marginLeft: 7, padding: 10, width: '100%', flexDirection: 'column', background: 'white' }}>
            <h4>How to Install</h4>
            <GridContainer xs={11} sm={11} md={5} style={{ marginTop: 15, marginBottom: 25, 
                display: 'flex', padding: 15, flexWrap: 'wrap', 
                border: '1px solid #C0C0C0', borderRadius: 8, alignItems: 'center' }}
                >
                <span>1</span>
                <img src={downlod} height={20} width={20} style={{ marginLeft: 10}} />
                <p style={{ fontSize: 14, marginLeft: 10 }}>Open download app to start installation</p>
            </GridContainer>
            <GridContainer xs={11} sm={11} md={5} style={{ marginTop: 15, marginBottom: 25, 
                display: 'flex', padding: 15, flexWrap: 'wrap', 
                border: '1px solid #C0C0C0', borderRadius: 8, alignItems: 'center' }}
                >
                <span style={{ margin: 3}}>2</span>
                <img src={allow} height={30} width={30} style={{ marginLeft: 10}} />
                <p style={{ marginLeft: 10}}>Allow from this source</p>
            </GridContainer>
        </div>
    </>
  )
}

export default Steps